import { useTranslation } from "react-i18next";
import { testimonials } from "@/mocks/articles";

export default function UserComments() {
  const { t } = useTranslation("home");

  const avatarImages: Record<string, string> = {
    "testimonial-1": "https://readdy.ai/api/search-image?query=young%20Chinese%20woman%20portrait%20with%20natural%20expression%2C%20warm%20lighting%20on%20face%2C%20casual%20everyday%20style%2C%20clean%20simple%20background%20with%20soft%20cream%20tones%2C%20editorial%20portrait%20photography%2C%20friendly%20approachable%20look&width=400&height=500&seq=testimonial-1&orientation=portrait",
    "testimonial-2": "https://readdy.ai/api/search-image?query=middle%20aged%20Chinese%20man%20portrait%20with%20confident%20expression%2C%20professional%20casual%20style%2C%20warm%20studio%20lighting%2C%20simple%20cream%20background%2C%20editorial%20portrait%20photography%2C%20experienced%20and%20trustworthy%20look&width=400&height=500&seq=testimonial-2&orientation=portrait",
    "testimonial-3": "https://readdy.ai/api/search-image?query=young%20Chinese%20female%20college%20student%20portrait%20with%20bright%20smile%2C%20casual%20youthful%20style%2C%20warm%20natural%20lighting%2C%20simple%20cream%20background%2C%20editorial%20portrait%20photography%2C%20energetic%20and%20fresh%20look&width=400&height=500&seq=testimonial-3&orientation=portrait",
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-900 tracking-tight">
            {t("testimonials.title")}
          </h2>
          <p className="mt-3 text-sm text-foreground-500">{t("testimonials.subtitle")}</p>
        </div>

        <div className="space-y-6">
          {testimonials.map((item, index) => (
            <div
              key={item.id}
              className={`bg-foreground-950 rounded-2xl overflow-hidden flex flex-col md:flex-row ${
                index % 2 === 1 ? "md:flex-row-reverse" : ""
              }`}
            >
              <div className="md:w-1/3 relative">
                <div className="h-64 md:h-full">
                  <img
                    src={avatarImages[item.avatarSeq] || avatarImages["testimonial-1"]}
                    alt={item.user}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="md:hidden absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950 to-transparent h-20"></div>
              </div>

              <div className="md:w-2/3 flex flex-col justify-center p-6 md:p-10">
                <span className="text-5xl md:text-6xl font-heading text-accent-400/30 leading-none select-none">
                  &ldquo;
                </span>
                <p className="text-base md:text-lg text-background-50 leading-relaxed -mt-4">
                  {item.content}
                </p>
                <div className="mt-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                  <div>
                    <p className="text-sm font-label font-medium text-background-50">{item.user}</p>
                    <p className="text-xs text-foreground-400 mt-0.5">{item.userTag}</p>
                  </div>
                  <button className="px-5 py-2 bg-accent-500/20 text-accent-400 hover:bg-accent-500/30 font-label text-sm rounded-full whitespace-nowrap transition-colors cursor-pointer">
                    {t("testimonials.viewPost")}
                    <i className="ri-arrow-right-line ml-1.5"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}